import React from "react";

import classNames from "classnames";
import PropTypes from "prop-types";

import { filters } from "components/pages/property/listing/mock/mockCollectionsResponse";
import { InquiryContextProvider } from "components/store/source";
import { Header, Section, Text } from "components/ui/source";
import { LoadingLayout } from "components/ui/source/layouts";

import Collection from "./Collection";
import CollectionCallout from "./CollectionCallout";
import CollectionPlaceholder from "./CollectionPlaceholder";
import EmptyResults from "./EmptyResults";
import SearchBar from "./Filters/SearchBar";

import styles from "./Collections.module.scss";

function Collections({
  id,
  className,
  collections,
  isCollectionLoading,
  checkIn,
  checkOut,
  selectedCollection,
}) {
  // Check if need to show the selected collection
  const needHighlight =
    collections &&
    selectedCollection &&
    collections.some(
      collection => collection.collectionId === selectedCollection,
    );

  // Pull the selected collection to the first of the array
  const allSortedCollections = needHighlight
    ? [...collections].sort((a, b) => {
        if (a.collectionId === selectedCollection) return -1;
        else if (b.collectionId === selectedCollection) return 1;
        return 0;
      })
    : collections;

  return (
    <Section id={id} className={classNames(className, styles.container)}>
      <Header
        className={styles.title}
        size="md"
        type="headline3"
        translateKey="listing:availability.title"
      />

      <SearchBar className={styles.searchBar} filters={filters} />

      <CollectionCallout className={styles.callout} />

      <Text
        className={styles.note}
        types={["caption2"]}
        translateKey="listing:availability.note"
      />

      <LoadingLayout className={styles.loader} loading={isCollectionLoading}>
        {isCollectionLoading && (
          <CollectionPlaceholder className={styles.collection} />
        )}

        {!isCollectionLoading && (
          <>
            {allSortedCollections && allSortedCollections.length == 0 && (
              <EmptyResults className={styles.emptyResults} />
            )}

            {allSortedCollections != null &&
              allSortedCollections.map(collection => (
                <InquiryContextProvider key={collection.collectionId}>
                  <Collection
                    className={classNames(
                      styles.collection,
                      selectedCollection === collection.collectionId &&
                        styles.highlighted,
                    )}
                    collection={collection}
                    isDateSet={checkIn && checkOut}
                  />
                </InquiryContextProvider>
              ))}
          </>
        )}
      </LoadingLayout>
    </Section>
  );
}

Collections.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  collections: PropTypes.array,
  isCollectionLoading: PropTypes.bool,
  checkIn: PropTypes.object,
  checkOut: PropTypes.object,
  selectedCollection: PropTypes.string,
};

export default Collections;
